import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { ApiAddResponse } from 'src/app/interfaces/api';
import { ResidenceService } from 'src/app/services/residence.service';
import { Residence } from '../../models/residence.model';

@Component({
    selector: 'app-residence-add',
    templateUrl: './residence-add.component.html',
    styleUrls: ['./residence-add.component.scss'],
})
export class ResidenceAddComponent {
  @Input() public prefill = '';

  @Output() private readonly residenceAdded = new EventEmitter<Residence>();

  @ViewChild('residenceName') public readonly residenceName!: ElementRef;

  public adding = false;

  constructor(public readonly residenceService: ResidenceService) {}

  public addResidence(event: Event): void {
    event.stopPropagation();
    event.preventDefault();
    const residence = new Residence();
    const nameElement = <HTMLInputElement>this.residenceName.nativeElement;
    residence.name = nameElement.value;
    residence.searchableName = residence.name.toLowerCase();
    this.adding = true;

    this.residenceService.createResidence(residence).subscribe({
      next: (addedResidence) => {
        const residenceResponse = <ApiAddResponse>addedResidence;
        this.residenceAdded.emit(<Residence>residenceResponse.data);
        this.adding = false;
      },
      error: () => {
        this.adding = false;
      },
    });
  }
}
